import { ExamDifficultyLevels } from "#/constants";
import clsx from "clsx";
import styles from "./difficultyLevel.module.scss";

type Props = {
  difficultyLevel: ExamDifficultyLevels;
};

const LEVEL_MAP: Record<ExamDifficultyLevels, number> = {
  [ExamDifficultyLevels.academic]: 1,
  [ExamDifficultyLevels.easy]: 1,
  [ExamDifficultyLevels.normal]: 2,
  [ExamDifficultyLevels.hard]: 3,
  [ExamDifficultyLevels.tooHard]: 3,
};

const TEXT_MAP: Record<number, string> = {
  1: "آسان",
  2: "متوسط",
  3: "سخت",
};

const CLASS_MAP: Record<number, string> = {
  1: "easy",
  2: "medium",
  3: "hard",
};

const DifficultyLevel: React.FC<Props> = ({ difficultyLevel }) => {
  const level = LEVEL_MAP[difficultyLevel] ?? 3;
  const activeBars = level * 3;
  const activeClass = CLASS_MAP[level];

  return (
    <div className={styles.level}>
      <div className={styles.level__bars}>
        {Array.from({ length: 9 }, (_, index) => (
          <div
            key={index}
            className={clsx(
              styles.level__bar,
              styles[`level--${index < activeBars ? activeClass : "neutral"}`],
            )}
          />
        ))}
      </div>
      <span className={styles.level__text}>{TEXT_MAP[level]}</span>
    </div>
  );
};

export default DifficultyLevel;
